

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faTimes } from '@fortawesome/free-solid-svg-icons';
import Header from './Header.js';


const Table = () => {
    return (


        <>

            <Header />



            <div className="container mt-5">
                <h1 className="text-center">Commandes En Attente</h1>

                <div className="table-responsive" style={{ maxHeight: '400px', overflowY: 'auto' }}>
                    <table className="table table-striped table-hover table-bordered table-responsive-sm shadow-sm mt-4">
                        <thead className="table-primary">
                            <tr>
                                <th>#</th>
                                <th>Nom du Menu</th>
                                <th>Description</th>
                                <th>Date de Commande</th>
                                <th>Quantité</th>
                                <th>Prix</th>
                                <th>Notes</th>
                                <th>Localisation</th>
                                <th>Status de la Commande</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td className="text-center align-middle">1</td>
                                <td className="text-center align-middle">Pizza Margherita</td>
                                <td className="text-center align-middle">Pizza avec sauce tomate, mozzarella et basilic</td>
                                <td className="text-center align-middle">21 févr. 2025, 14:30</td>
                                <td className="text-center align-middle">2</td>
                                <td className="text-center align-middle bg-primary-subtle">20 €</td>
                                <td className="text-center align-middle">Aucune note spéciale</td>
                                <td className="text-center align-middle bg-danger text-white">Paris, France</td>
                                <td className="text-center align-middle bg-warning text-white">En attente</td>
                                <td>
                                    <div className="d-flex align-items-center justify-content-center">
                                        <button className="btn btn-success btn-sm me-2">
                                            <FontAwesomeIcon icon={faCheck} />
                                        </button>
                                        <button className="btn btn-danger btn-sm">
                                            <FontAwesomeIcon icon={faTimes} />
                                        </button>
                                    </div>
                                </td>
                            </tr>

                        </tbody>
                    </table>
                </div>
            </div>

        </>
    )
}

export default Table;